export const LIST_MODE = "LIST_MODE";
export const SORT_MODE = "SORT_MODE";
export const SET_FILTER = "SET_FILTER";
